import { createContext, useContext } from 'react';

export const ThumbnailContext = createContext(false);

export const useThumbnail = () => useContext(ThumbnailContext);
